import { mergeAttributes } from '@tiptap/core';
import { createColGroup, Table } from '@tiptap/extension-table';
import { DOMOutputSpec } from '@tiptap/pm/model';

export const TableResponsive = Table.extend({
  renderHTML({ node, HTMLAttributes }) {
    const { colgroup, tableWidth, tableMinWidth } = createColGroup(
      node,
      this.options.cellMinWidth,
    );

    const table: DOMOutputSpec = [
      'div',
      {
        class: 'table-responsive',
      },
      [
        'table',
        mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
          style: tableWidth
            ? `width: ${tableWidth}`
            : `min-width: ${tableMinWidth}`,
        }),
        colgroup,
        ['tbody', 0],
      ],
    ];

    return table;
  },
});
